// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Actions
import { alerts } from 'modules/alerts/actions';

// Services
import Ticket from 'services/data/ticket';

// Components
import TicketlessTimeReportForm from './ticketless-time-report-form';
import FormPopover from 'components/widgets/overlays/form';
import { SVGButton } from 'components/widgets/buttons/buttons';
import TicketLink from 'components/models/ticket/ticket-link';


// Component
class AddTimeReportPopup extends React.Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.createTimeReport = this.createTimeReport.bind(this);
  }

  createTimeReport(values) {
    const { currentUser } = this.props;

    return Ticket.create({
      company: values.company,
      agreement: values.agreement,
      status: 'Closed',
      description: values.ticketDescription,
      createdBy: currentUser.id,
      timeDefaultBillable: values.timeDefaultBillable,
      resolution: `[Populated by creation of ad-hoc time report] ${values.timeReportDescription}`,
      timeReports: [{
        description: values.timeReportDescription,
        duration: values.timeReportDuration,
        createdBy: currentUser.id,
        agreement: values.agreement,
        date: values.date,
        rate: values.rate,
        afterHours: values.afterHours,
        afterHoursPremium: values.afterHours ? values.afterHoursPremium : 0
      }]
    })
      .then((ticket) =>
        alerts.success({
          title: 'Time report added!',
          subtitle: <TicketLink ticket={ticket} linkSuffix="/time">View in ticket</TicketLink>
        })
      )
      .then(this.addForm.toggle);
  }

  render() {
    return (
      <div>
        <FormPopover
          ref={(el) => { this.addForm = el; }}
          target={<SVGButton src="svg/add.svg" className="add-item-link" />}
          title="Add Time Report"
        >
          <TicketlessTimeReportForm
            {...this.props}
            onSubmit={this.createTimeReport}
            form="add-time-report-popup"
          />
        </FormPopover>
      </div>
    );
  }
}

export default connect((state) => ({
  currentUser: state.auth.currentUser
}))(AddTimeReportPopup);



// WEBPACK FOOTER //
// ./app/components/models/time-report/forms/add-time-report-popup.js